<template>
  <v-card>
    <v-card-text>
    <v-row>
        <v-col>
            <v-dialog v-model="dialog" max-width="1200">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        color="primary"
                        dark
                        v-bind="attrs"
                        v-on="on"
                    >
                        Добавить адрес
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span class="text-h5">Добавление адреса</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-col cols="12">
                                <fias-house-form @added-address="onAddedAddress"></fias-house-form>
                            </v-col>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="dialog = false"
                        >
                            Закрыть
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-col>
    </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table
                    :single-expand="true"
                    :headers="tableHeaders"
                    :loading="isFetch"
                    :items="houses"
                    disable-pagination
                    class="elevation-1"
                    hide-default-footer
                >
                <template v-slot:top>
                    <v-text-field
                        v-model="search"
                        label="Поиск адреса"
                        class="mx-4"
                    ></v-text-field>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-btn
                        depressed
                        color="success"
                        @click="onUpdate(item.fias_house_id)"
                    >
                        <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-btn
                        depressed
                        color="error"
                        @click="onRemove(item.fias_house_id)"
                    >
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <div class="text-center">
                    <v-pagination
                        v-model="meta.current_page"
                        :length="meta.last_page"
                        total-visible="25"
                        @input="onPaginate"
                    ></v-pagination>
                </div>
            </v-col>
        </v-row>
        <v-dialog v-model="dialogDelete" max-width="800px">
            <v-card>
                <v-card-title class="text-h5">Удалить {{removingAddress}} ?</v-card-title>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeRemove">Отмена</v-btn>
                <v-btn color="blue darken-1" text @click="remove(removefiasHouseId)">OK</v-btn>
                <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card-text>
    </v-card>
</template>

<script>
import _ from 'lodash';
import {mapGetters, mapActions} from 'vuex';
import * as organizationApi from '@/api/organizations';
import FiasHouseForm from '../components/houses/FiasHouseForm.vue';
export default {
    name: 'HouseFias',
    components:{FiasHouseForm},
    data(){
        return {
            search: '',
            dialogDelete: false,
            removefiasHouseId: null,
            dialog: false,
            houses: [],
            meta: {
                current_page: 1,
                last_page: 1
            },
            isFetch: false,
            tableHeaders: [
                { text: 'Уникальный номер ГАР (FIAS ID)', value: 'fias_house_guid'},
                { text: 'Кадастровый номер', value: 'cadastral_number'},
                { text: 'Адрес', value: 'fias_house_address'},
                { text: 'Кем добавлено', value: 'creator_user_name'},
                { text: 'Когда добавлено', value: 'created_at'},
                { text: 'Действия', value: 'actions'},
            ]
        }
    },

    created(){
        this.load();
    },
    watch:{
        ORGANIZATION_ID (){
            this.reset();
            this.load();
        },
        search(){
            this.onInputSearch()
        }
      },
    methods: {
        ...mapActions('notifications', ['SHOW_MESSAGE', 'SHOW_ERROR', 'SHOW_SUCCESS', 'SHOW_RESPONSE_ERROR']),
        onAddedAddress(){
            this.load();
            this.dialog = false;
        },
        onInputSearch: _.debounce(function(){
            this.reset();
            this.load();
        }, 1000),

        reset(){
            this.meta.current_page = 1;
            this.meta.last_page = 1;
            this.houses.splice(0, this.houses.length);
        },
        async load(){
            this.isFetch = true;
            try{
                let { data } = await organizationApi.organizationFiasHouses(this.ID_WORK_SPACE, this.ORGANIZATION_ID, this.loadParams);
                this.houses.splice(0, this.houses.length, ...data.data);
                this.meta = {...this.meta, ...data.meta}
            }catch(e){
                console.log(e);
            }finally{
                this.isFetch = false;
            }
        },
        onPaginate(){
            this.load();
        },
        onRemove(fiasHouseId){
            this.removefiasHouseId = fiasHouseId;
            this.dialogDelete = true;
        },
        remove(fiasHouseId){
            organizationApi.organizationFiasHouseRemove(this.ID_WORK_SPACE, this.ORGANIZATION_ID, fiasHouseId).then(({data}) => {
                this.SHOW_SUCCESS(data.message);
                this.load();
            }).catch(err => {
                console.log(err);
                this.SHOW_SUCCESS("Произошла ошибка удаления. Повторите попытку");
            }).finally(() => {
                this.closeRemove();
            });
        },
        async onUpdate(fiasHouseId){
            await this.update(fiasHouseId);
        },
        async update(fiasHouseId){
            try{
                let {data} = await organizationApi.organizationFiasHouseUpdate(this.ID_WORK_SPACE, this.ORGANIZATION_ID, fiasHouseId);
                this.SHOW_SUCCESS(data.message);
            }catch(e){
                console.log(e);
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Произошла ошибка обновления ('});
            }finally{
                this.load();
            }
        },
        closeRemove(){
            this.dialogDelete = false;
            this.removefiasHouseId = null;
        }
    },
    computed: {
        removingAddress(){
            if(this.removefiasHouseId != null){
                let house = this.houses.find(house => house.fias_house_id === this.removefiasHouseId);
                if(house){
                    return house.fias_house_address;
                }
            }
            return '';
        },

        loadParams(){
            return {
                page: this.meta.current_page,
                search: this.search
            };
        },
        ...mapGetters( 'workspace', ['ID_WORK_SPACE', 'ORGANIZATION_ID']),
    }
}
</script>